var Backbone = require('backbone');

var UISettings = Backbone.Model.extend({
  defaults: {
    showLegends: true,
    showLayerSelector: false
  }
});

module.exports = UISettings;



//////////////////
// WEBPACK FOOTER
// ./~/internal-carto.js/src/vis/settings.js
// module id = 1701
// module chunks = 6